<template>
   <div class="row yo-text-n white evento" :class="'device-'+$teras.app.device">

   
   <div class="row">
      <div class="col clear s6 ms yo-hidden-phone" ><div style="margin-top:60px;height:110px;border-left:3px solid grey;border-top:3px solid grey;">&#160;</div></div>
      <div class="col s12 m11m">

        <provider :evento="evento" :rowheight="evheight" ></provider>
        <div class="row">
          <div class="main col mm yo-hidden-phone" :style="'height:'+evheight+'px'">&#160;</div>
          <crediti v-if="evento.isecm==1" :evento="evento" :rowheight="evheight" :info="false"></crediti>
          <titolo :evento="evento" :rowheight="evheight" v-on:change="val => evheight=val"></titolo>
        </div>

      </div>
      <div class="col s6 ms  yo-hidden-phone" ><div style="margin-top:60px;height:110px;border-right:3px solid grey;border-top:3px solid grey;">&#160;</div></div>   
   </div>

   <div class="row" style="clear:both;">



      <div class="col clear s6 ms yo-hidden-phone" ><div style="border-left:3px solid grey;height:80px;">&#160;</div></div>
      <div class="col s12 m11m">
         <div class="row ">
            
            <a v-if="evento.iniziato==0 && evento.badge==1" :href="'https://bvent.biomedia.net/index/autologin/evento/'+evento.evento+'/idcheck/'+$contatto.row.id+'/id/'+$contatto.idencrypt" target="_blank">
            <div class="info col s4 mx offset-mm yo-align-center" ><img src="../assets/ico-badge.png" style="height:50px;"/></div>
            <div class="col s6 m1m  yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">BADGE</div>
            </a>

            <a :href="'https://bvent.biomedia.net/index/autologin/evento/'+evento.evento+'/idcheck/'+$contatto.row.id+'/id/'+$contatto.idencrypt" target="_blank">
            <div class="info col s4 mx yo-align-center" ><img src="../assets/ico-iscrizione.png" style="height:50px;"/></div>
            <div class="col s6 m1m yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">GESTIONE<br />ISCRIZIONE</div>
            </a>
            
            
            <!--
            <a v-if="evento.isecm==1" :href="'https://bvent.biomedia.net/providerecm/autologin/evento/'+evento.evento+'/idcheck/'+$contatto.row.id+'/id/'+$contatto.idencrypt" target="_blank">
            <div class="info col s4 mx yo-align-center" ><img src="../assets/ico-atti.png" style="height:50px;"/></div>
            <div class="col s6 m1m yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">ATTI</div>
            </a>
            -->

            <a v-if="evento.atti==1" :href="'https://bvent.biomedia.net/atti/'+evento.evento+'.zip'" target="_blank">
            <div class="info col s4 mx yo-align-center" ><img src="../assets/ico-atti.png" style="height:50px;"/></div>
            <div class="col s6 m1m yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">SLIDES</div>
            </a>

            <div v-if="evento.atti==2" class="info col s4 mx yo-align-center" ><img src="../assets/ico-atti.png" style="height:50px;"/></div>
            <div v-if="evento.atti==2" class="col s6 m1m yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">SLIDES (presto disponibile)</div>

            <a v-if="evento.isecm==1" :href="'https://bvent.biomedia.net/providerecm/autologin/evento/'+evento.evento+'/idcheck/'+$contatto.row.id+'/id/'+$contatto.idencrypt" target="_blank">
            <div class="info col s4 mx yo-align-center" ><img src="../assets/ico-ecm.png" style="height:50px;"/></div>
            <div class="col s6 m1s yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">ECM</div>
            </a>

            <a v-if="evento.attestatofreq==1 && evento.presente==1"  :href="'https://bvent.biomedia.net/attestatofrequenza/'+$contatto.idencrypt+'/'+$contatto.row.id+'/'+evento.evento" target="_blank">
            <div class="info col s4 mx yo-align-center" ><img src="../assets/ico-attestato.png" style="height:50px;"/></div>
            <div class="col s6 m1x yo-valign-text-center yo-hidden-phone" style="height:50px;color:#353535;">ATTESTATI DI<br />PARTECIPAZIONE</div>
            </a>

            
         </div>
      </div>
      <div class="col s6 ms  yo-hidden-phone" ><div style="border-right:3px solid grey;height:80px;">&#160;</div></div>
      </div>

      <div class="col ss  yo-hidden-phone" ><div style="height:3px;border-left:3px solid grey;border-bottom:3px solid grey;">&#160;</div></div>
      <div class="col s11m  yo-hidden-phone" ><div style="height:3px;border-bottom:3px solid grey;">&#160;</div></div>
      <div class="col ss  yo-hidden-phone" ><div style="height:3px;border-right:3px solid grey;border-bottom:3px solid grey;">&#160;</div></div>

   </div>
</template>

<script>
import provider from './Evento-elenco-provider'
import crediti from './Evento-elenco-crediti'
import titolo from './Evento-elenco-titolo-res'
export default {
   props: {
      evento: Object
  },
  components: {
    provider
    ,crediti
    ,titolo
  },
  data(){
    return{
      evheight: 0
    }
  }
}
</script>


<style>
.mylogin-elenco-res .evento{
   padding: 0 20px;
   margin-bottom:20px;
}
.mylogin-elenco-res .provider{
   border-bottom:10px solid #379EC2;
   color:#353535;
   padding-bottom:4px !important;
}
.mylogin-elenco-res > .evento:nth-child(2n) .provider{
  border-bottom:10px solid #0E1C3C;
}
.mylogin-elenco-res .side{
   background: #379EC2;
   height:100px;
   padding:0 0 0 20px !important;
}
.mylogin-elenco-res  > .evento:nth-child(2n)  .side {
  background: #0E1C3C;
}
.mylogin-elenco-res .info div{
   background: #0E1C3C;
}
.mylogin-elenco-res  > .evento:nth-child(2n)  .info div{
  background: #379EC2;
}
.mylogin-elenco-res  .main{
   background: #379EC2;
   min-height:100px;
}.mylogin-elenco-res .device-desktop .main{
   height:100px;
   /*padding:0 0 0 20px !important; */
}.mylogin-elenco-res .device-mobile .main{
   padding-top:20px;
   margin-bottom:30px;
}
.mylogin-elenco-res  > .evento:nth-child(2n)  .main {
  background: #0E1C3C;
}




</style>



// WEBPACK FOOTER //
// src/components/Mylogin-elenco-res.vue